export var LOADING_TEXT = "Loading...";
